var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClients = function SvgClients(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 16.667H4.16675C2.78591 16.667 1.66675 15.5478 1.66675 14.167V4.16699H15.8334C17.2142 4.16699 18.3334 5.28616 18.3334 6.66699V14.167C18.3334 15.5478 17.2142 16.667 15.8334 16.667Z",
    fill: "#E3F2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.667C7.5 16.5707 7.5 16.4751 7.5 16.3545C7.5 15.837 7.12667 15.417 6.66667 15.417C6.20667 15.417 5.83333 15.837 5.83333 16.3545C5.83333 16.4751 5.83333 16.5707 5.83333 16.667L7.5 16.667Z",
    fill: "#90C9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.667C15 16.5707 15 16.4751 15 16.3545C15 15.837 14.6267 15.417 14.1667 15.417C13.7067 15.417 13.3333 15.837 13.3333 16.3545C13.3333 16.4751 13.3333 16.5707 13.3333 16.667L15 16.667Z",
    fill: "#90C9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 9.16634C7.17039 9.16634 7.91658 8.42015 7.91658 7.49967C7.91658 6.5792 7.17039 5.83301 6.24992 5.83301C5.32944 5.83301 4.58325 6.5792 4.58325 7.49967C4.58325 8.42015 5.32944 9.16634 6.24992 9.16634Z",
    fill: "#1F87E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 12.9167C3.33325 11.3058 4.63909 10 6.24992 10C7.86075 10 9.16658 11.3058 9.16658 12.9167V13.3333H3.33325V12.9167Z",
    fill: "#1F87E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8333,
    y: 8.33301,
    width: 5.83333,
    height: 1.25,
    rx: 0.625,
    fill: "#1F87E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8333,
    y: 10,
    width: 5.83333,
    height: 1.25,
    rx: 0.625,
    fill: "#1F87E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8333,
    y: 11.667,
    width: 5.83333,
    height: 1.25,
    rx: 0.625,
    fill: "#1F87E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 4.16699H1.66675V3.33366C1.66675 2.41283 2.41258 1.66699 3.33341 1.66699H7.13175C7.84925 1.66699 8.48591 2.12616 8.71258 2.80699L9.16675 4.16699Z",
    fill: "#90C9F9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClients);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "clients.46828b60e1fed4f97fdf57328cf20cd6.svg";